import { SITE_URL } from "@/utils/site";

interface SeoProps {
  title: string;
  description: string;
  keywords: string;
  path: string;
  ogType?: string;
  image?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

const DEFAULT_IMAGE =
  "https://readdy.ai/api/search-image?query=Friendly%20vibrant%20community%20illustration%20with%20abstract%20speech%20bubbles%20and%20green%20field%20motifs%2C%20warm%20cream%20and%20coral%20tones%2C%20modern%20editorial%20graphic%20style%2C%20no%20text&width=1200&height=630&seq=gt-og-cover&orientation=landscape";

export default function Seo({
  title,
  description,
  keywords,
  path,
  ogType = "website",
  image = DEFAULT_IMAGE,
  jsonLd,
}: SeoProps) {
  const canonical = `${SITE_URL}${path}`;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow, max-image-preview:large" />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content="瓜田社区" />
      <meta property="og:locale" content="zh_CN" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd ? (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      ) : null}
    </>
  );
}